var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBubble10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 117,
    viewBox: "0 0 248 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M97.3185 -126.418C126.372 -124.108 152.595 -115.673 176.295 -100.608C206.326 -81.5196 248.707 -63.3831 247.991 -30.6457C247.276 2.05481 198.069 12.4093 173.294 36.659C145.817 63.5538 138.116 113.73 97.3185 116.834C56.5318 119.937 30.8877 78.7983 7.06695 49.3054C-12.0393 25.6497 -21.0348 -1.56628 -21.7979 -30.6457C-22.5845 -60.625 -22.2948 -94.2485 2.77127 -114.402C27.28 -134.108 64.3528 -129.038 97.3185 -126.418Z",
    fill: "url(#paint0_linear_1431_13)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1431_13",
    x1: -22,
    y1: -6,
    x2: 248,
    y2: -6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D31027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA384D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble10);
export default __webpack_public_path__ + "static/media/bubble_10.f9de4cccc3e062c8f41664b288a41f1a.svg";
export { ForwardRef as ReactComponent };